import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipeToBr',
  pure: true,
})
export class PipeToBrPipe implements PipeTransform {
  transform(value: string, double = false) {
    return value.split('|').join(double ? '<br/><br/>' : '<br/>');
  }
}
